import {pretty} from '../lib/formatting';

export const formatAddresses = (stateAddresses) => {
  stateAddresses.content.map((address) => {
    address = pretty(address);
  })
  return stateAddresses;
}
